export enum UserRoles {
	Admin = 'ROLE_ADMIN',
}
